/* load-more Button functionality */
document.addEventListener('DOMContentLoaded', function () {
    let loadMoreBtn = document.querySelector('.tx_events.events_filterlist+.loadmore');
    let articles = document.querySelectorAll('.tx_events.events_filterlist .news-list-view .article');

    function getItemsPerRow() {
        let containerWidth = document.querySelector('.news-list-view').clientWidth;
        let articleWidth = articles[0] ? articles[0].clientWidth : 1;
        return Math.floor(containerWidth / articleWidth);
    }

    function updateVisibility() {
        let itemsPerRow = getItemsPerRow();
        let visibleItems = itemsPerRow * 2;

        articles.forEach((article, index) => {
            if (index < visibleItems) {
                article.classList.remove('hidden');
            } else {
                article.classList.add('hidden');
            }
        });

        if (loadMoreBtn) {
            let hiddenArticles = document.querySelectorAll('.tx_events.events_filterlist .news-list-view .article.hidden');
            loadMoreBtn.classList.toggle('hidden', hiddenArticles.length === 0);
        }
    }

    function loadMore() {
        let currentlyVisible = document.querySelectorAll('.tx_events.events_filterlist .news-list-view .article:not(.hidden)').length;
        let itemsPerRow = getItemsPerRow();
        let newVisibleCount = currentlyVisible + itemsPerRow * 2;

        articles.forEach((article, index) => {
            if (index < newVisibleCount) {
                article.classList.remove('hidden');
            }
        });

        if (loadMoreBtn) {
            let hiddenArticles = document.querySelectorAll('.tx_events.events_filterlist .news-list-view .article.hidden');
            loadMoreBtn.classList.toggle('hidden', hiddenArticles.length === 0);
        }
    }

    if (articles.length > 0) {
        updateVisibility();
    }

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            loadMore();
        });
    }


    let lastWidth = window.innerWidth;

    window.addEventListener('resize', () => {
        const currentWidth = window.innerWidth;

        if (currentWidth !== lastWidth) {
            lastWidth = currentWidth;
            updateVisibility();
        }
    });
});